import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20home%20theater%20with%20warm%20ambient%20lighting%2C%20red%20velvet%20curtains%2C%20golden%20decorative%20elements%2C%20elegant%20classic%20cinema%20interior%2C%20soft%20warm%20glow%2C%20luxurious%20atmosphere%2C%20wide%20angle%20shot%2C%20dark%20rich%20tones%20with%20golden%20accents&width=1600&height=900&seq=hero-bg&orientation=landscape"
        alt="天天影院"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/30 to-foreground-950/70"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="w-full max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
            最新电视剧全集在线观看
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            国产剧全集在线 · 韩剧全集免费 · 美剧全集播放 · 日剧全集资源
            <br className="hidden md:block" />
            追剧无需等待，全部剧集一网打尽
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap"
            >
              立即追剧
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border-2 border-background-50/40 hover:border-background-50 text-background-50 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}